import { apiClient } from './client';
import { TokenResponse } from '../types';

export interface CreateTokenRequest {
  customerId: string;
  tool: string;
  accessToken: string;
  refreshToken?: string;
  expiresAt?: string;
  tokenUrl?: string;
  metadata?: string;
}

export const getTokens = () =>
  apiClient.get<TokenResponse[]>('/api/tokens').then(r => r.data);

export const createToken = (req: CreateTokenRequest) =>
  apiClient.post<TokenResponse>('/api/tokens', req).then(r => r.data);

export const deleteToken = (id: string) =>
  apiClient.delete(`/api/tokens/${id}`).then(() => {});

export const startOAuth = (tool: string, customerId: string) =>
  apiClient.get<{ authUrl: string }>(
    `/api/tokens/oauth/${tool}/start?customerId=${encodeURIComponent(customerId)}`
  ).then(r => r.data);
